export const CSS_PREFIX = 'panorama';
